module.exports = __webpack_public_path__ + "img/public/AdminIcons/whistListEditIcon.svg?2203433b";